import React from "react";
import { Button } from "reactstrap";

const FACE_FILTER_OPTIONS = [
  { label: "Todos", value: "all" },
  { label: "Com Face ID", value: "hasFace" },
  { label: "Sem Face ID", value: "hasNotFace" },
];

export default function CommandButtons({
  searchControl,
  setSearchControl,
  lastSearchStringUpdate,
  getData,
  getReport,
}) {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 10,
        gap: 10,
        flexWrap: "wrap",
      }}
    >
      <form
        className="app-search d-none d-lg-block events-input-search"
        onSubmit={(e) => e.preventDefault()}
      >
        <div className="position-relative">
          <input
            value={searchControl.search}
            type="text"
            className="form-control"
            placeholder="Pesquisar..."
            onChange={(e) => {
              setSearchControl({ ...searchControl, search: e.target.value });
              lastSearchStringUpdate.current = Date.now();
              setTimeout(() => {
                if (lastSearchStringUpdate.current + 500 < Date.now()) {
                  getData();
                }
              }, 600);
            }}
          />
          <span className="bx bx-search-alt" />
        </div>
      </form>

      <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", gap: 10, margin: 0 }}>
        <Button
          color="success"
          className="waves-effect waves-light"
          style={{ display: "flex", alignItems: "center", gap: 6 }}
          onClick={getReport}
        >
          <i className="fas fa-file-excel" />
          Extrair Relatório
        </Button>
        <select
          className="form-select"
          style={{ width: "auto", minWidth: 160 }}
          value={searchControl.filter}
          onChange={(e) => {
            setSearchControl({ ...searchControl, filter: e.target.value });
            setTimeout(() => {
              getData();
            }, 100);
          }}
        >
          {FACE_FILTER_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
